// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../styles/register-page-layout.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.note-register-card {
  background: var(--surface-primary);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-lg, 16px);
  box-shadow: var(--shadow-sm);
  overflow: hidden;
}
.note-register-summary,
.note-register-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 16px;
  font-size: 13px;
  color: var(--text-secondary);
}
.note-register-summary strong {
  color: var(--text-primary);
  font-weight: 500;
}
.note-table-scroll {
  overflow-x: auto;
}
.note-table-scroll table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  line-height: 1.5;
}
.note-table-scroll th {
  padding: 12px 16px;
  text-align: left;
  font-weight: 500;
  color: var(--text-secondary);
  background: var(--surface-secondary);
  white-space: nowrap;
  border-block: 1px solid var(--border-subtle);
}
.note-table-scroll td {
  padding: 18px 16px;
  border-bottom: 1px solid var(--border-subtle);
  vertical-align: middle;
}
.note-table-scroll th:nth-last-child(2),
.note-amount {
  text-align: right;
  white-space: nowrap;
}
.note-table-scroll td.note-contact {
  max-width: 190px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.note-table-scroll .note-reference {
  color: var(--interactive-default);
  font-family: var(--font-family-mono, monospace);
  text-decoration: none;
  white-space: nowrap;
}
.note-table-scroll .note-reference:hover {
  text-decoration: underline;
}
.note-amount {
  font: 500 15px var(--font-family-mono, monospace);
}
.note-status {
  display: inline-block;
  padding: 3px 6px;
  border-radius: var(--radius-full, 999px);
  font-size: 11px;
  font-weight: 500;
  white-space: nowrap;
  background: var(--surface-tertiary, var(--surface-secondary));
  color: var(--text-secondary);
}
.note-status-applied {
  background: var(--success-soft);
  color: var(--success-text);
}
.note-status-issued,
.note-status-refunded {
  background: var(--info-soft);
  color: var(--info-text);
}
.note-status-awaiting-confirmation {
  background: var(--warning-soft);
  color: var(--warning-text);
}
.note-delivery-failed {
  display: block;
  color: var(--danger-text);
  font-size: 11px;
  margin-top: 5px;
}
.note-register-footer div {
  display: flex;
  gap: 8px;
}
.note-register-footer button {
  display: grid;
  place-items: center;
  width: 32px;
  height: 32px;
  border: 1px solid var(--border-default);
  background: var(--surface-primary);
  color: var(--text-secondary);
  border-radius: var(--radius-sm, 6px);
  cursor: pointer;
}
.note-register-footer button:disabled {
  opacity: 0.4;
  cursor: default;
}
.note-register-footer button:not(:disabled):hover {
  border-color: var(--interactive-default);
  background: var(--interactive-soft);
  color: var(--interactive-hover);
}
.note-register-footer button:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
}
.note-register-guidance {
  margin: 24px 0;
  font-size: 13px;
  line-height: 1.6;
  color: var(--text-secondary);
}
.note-empty {
  padding: 48px 24px;
  text-align: center;
  color: var(--text-secondary);
}
.note-empty h2 {
  font-size: 18px;
  color: var(--text-primary);
}
.debit-confirm-checkbox {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px 0;
  font-size: 13px;
  line-height: 1.5;
}
.debit-confirm-checkbox input {
  margin-top: 3px;
  accent-color: var(--interactive-default);
  width: 18px;
  height: 18px;
  flex: 0 0 18px;
}
.debit-modal {
  background: var(--surface-primary);
  color: var(--text-primary);
}
.debit-page .debit-description input {
  width: 100%;
}
.note-confirm-grid {
  display: grid;
  gap: 18px;
}
.note-confirm-grid label {
  display: grid;
  gap: 8px;
  font-size: 13px;
  color: var(--text-secondary);
}
.note-confirm-grid input,
.note-confirm-grid select {
  width: 100%;
  min-height: 42px;
  padding: 10px 12px;
  border: 1px solid var(--border-default);
  border-radius: var(--radius-md, 10px);
  background: var(--surface-primary);
  color: var(--text-primary);
  font: inherit;
}
.note-confirm-grid .debit-confirm-checkbox {
  display: flex;
}
.note-confirm-grid .debit-confirm-checkbox input {
  width: 18px;
  min-height: 18px;
  padding: 0;
}
.note-detail-events {
  padding-left: 20px;
  color: var(--text-secondary);
  font-size: 13px;
  line-height: 1.8;
}
@media (max-width: 767px) {
  .note-register-summary,
  .note-register-footer {
    padding: 12px;
    font-size: 11px;
  }
  .note-table-scroll table {
    min-width: 920px;
  }
  .note-table-scroll td,
  .note-table-scroll th {
    padding: 14px 12px;
  }
  .note-register-guidance {
    font-size: 12px;
    margin-top: 20px;
  }
  .adjustment-register .debit-search {
    flex: 1 0 100%;
    width: 100%;
  }
  .adjustment-register .debit-filters {
    flex-wrap: wrap;
  }
  .adjustment-register .debit-filter-group {
    width: 100%;
  }
  .adjustment-register .debit-filter-group > * {
    flex: 1 1 120px;
  }
}

.debit-editor-form {
  border: 0;
  margin: 0;
}
.debit-page .debit-editor-title h1 {
  font-size: 32px;
  line-height: 40px;
  letter-spacing: -0.48px;
}
@media (max-width: 1024px) {
  .debit-page .debit-editor-title h1 {
    font-size: 28px;
    line-height: 35px;
  }
}
@media (max-width: 767px) {
  .debit-page .debit-editor-title h1 {
    font-size: 24px;
    line-height: 30px;
  }
}
.adjustment-register .debit-filter-group {
  flex-wrap: wrap;
  flex: 1 1 auto;
}
.adjustment-register .debit-filter-group > .quotation-figma-dropdown {
  width: auto;
  flex: 0 1 auto;
  min-width: 130px;
  max-width: 240px;
}
.adjustment-register
  .debit-filter-group
  > .quotation-figma-dropdown:last-child {
  min-width: 150px;
}
.adjustment-register:is(.note-register--credit, .note-register--debit) .debit-filter-group {
  display: grid;
  grid-template-columns: repeat(3, 134px) auto;
  gap: 12px;
  flex: 0 1 auto;
  width: auto;
  min-width: 0;
}
.adjustment-register:is(.note-register--credit, .note-register--debit)
  .debit-filter-group > .quotation-figma-dropdown {
  flex: 0 0 134px;
  width: 134px;
  min-width: 134px;
  max-width: 134px;
}
.adjustment-register:is(.note-register--credit, .note-register--debit)
  .debit-filter-group .quotation-figma-dropdown-trigger {
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  height: 40px;
  padding-inline: 12px;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: var(--radius-md, 10px);
  font-size: 13px;
  font-weight: 500;
}
.adjustment-register:is(.note-register--credit, .note-register--debit)
  .debit-filter-group .quotation-figma-dropdown-trigger:hover {
  border-color: var(--border-strong, #aebab8);
}
.adjustment-register:is(.note-register--credit, .note-register--debit)
  .debit-filter-group .quotation-figma-dropdown.is-open
  .quotation-figma-dropdown-trigger,
.adjustment-register:is(.note-register--credit, .note-register--debit)
  .debit-filter-group .quotation-figma-dropdown-trigger:focus-visible {
  border-width: 1px;
  padding-inline: 12px;
  border-color: var(--interactive-default, #0f766e);
  box-shadow: none;
}
.adjustment-register:is(.note-register--credit, .note-register--debit) .debit-clear-filters {
  justify-content: center;
  height: 40px;
  padding: 0 14px;
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: 10px;
  background: var(--surface-primary, #fff);
  color: var(--text-primary, #142624);
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
  transition: background 0.15s ease, border-color 0.15s ease;
}
.adjustment-register:is(.note-register--credit, .note-register--debit) .debit-clear-filters:hover {
  background: var(--surface-secondary, #f4f7f7);
  border-color: var(--border-default, #cdd6d4);
  color: var(--text-primary, #142624);
  text-decoration: none;
}
@media (max-width: 767px) {
  .adjustment-register:is(.note-register--credit, .note-register--debit) .debit-filter-group {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    width: 100%;
  }
  .adjustment-register:is(.note-register--credit, .note-register--debit)
    .debit-filter-group > .quotation-figma-dropdown {
    width: 100%;
    min-width: 0;
    max-width: none;
  }
  .adjustment-register:is(.note-register--credit, .note-register--debit)
    .debit-filter-group > .quotation-figma-dropdown:last-of-type {
    grid-column: auto;
  }
}
.debit-page .note-register-guidance {
  margin-top: 24px;
}
.debit-page .listing-actions-trigger {
  display: inline-grid;
  place-items: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 0;
  border-radius: var(--radius-sm);
  background: transparent;
  color: var(--text-secondary);
  cursor: pointer;
}
.debit-page .listing-actions-trigger:hover {
  background: var(--surface-secondary);
}
.debit-source-select-wrap > svg {
  display: none;
}
.debit-source-select .quotation-input-box {
  height: 40px;
}
.debit-page .debit-source-select input {
  border: 0;
  background: transparent;
  border-radius: 0;
  box-shadow: none;
  height: 38px;
  padding: 0;
}
.debit-selected-source > div:first-child > span {
  color: var(--text-primary);
  font-weight: 500;
}
.debit-selected-source > div:last-child > strong {
  color: var(--text-primary);
  font-size: 15px;
}
.debit-editor-actions-bottom {
  justify-content: flex-end;
  width: 100%;
}
.debit-page .debit-lines-table {
  overflow: hidden;
}
@media (max-width: 1024px) {
  .adjustment-register .debit-filters {
    flex-wrap: wrap;
  }
}
@media (max-width: 767px) {
  .adjustment-register .debit-filter-group > .quotation-figma-dropdown {
    flex: 1 1 120px;
    max-width: none;
  }
}
.debit-organisation-menu > a {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  color: var(--text-primary);
  text-decoration: none;
  font-size: 13px;
}
.debit-organisation-menu > a:hover {
  background: var(--surface-secondary);
}
@media (max-width: 767px) {
  .debit-description .sr-only {
    position: static;
    width: auto;
    height: auto;
    margin: 0 0 6px;
    clip: auto;
    overflow: visible;
    color: var(--text-secondary);
    font-size: 12px;
  }
}
.note-unit-field {
  position: relative;
  min-width: 0;
  width: 100%;
}
.note-unit-field > span {
  position: absolute;
  left: 9px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  font-family: var(--font-family-mono, monospace);
}
.debit-page .note-unit-field input {
  padding-left: 22px;
  font-family: var(--font-family-mono, monospace);
}
.debit-preview .note-preview-lines {
  display: none;
}
@media (max-width: 767px) {
  .debit-preview-responsive .note-preview-lines {
    display: block;
  }
  .note-preview-lines p {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    font-size: 12px;
  }
}
.note-confirm-balance {
  padding: 12px 16px;
  margin-block: 16px;
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-md);
  background: var(--surface-secondary);
}
.note-confirm-balance p {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 16px;
  color: var(--text-secondary);
  font-size: 13px;
}
.note-confirm-balance strong {
  font-family: var(--font-family-mono, monospace);
  color: var(--text-primary);
  white-space: nowrap;
}
body:has(.debit-page) .dashboard-sidebar-launcher,
body:has(.credit-detail-shell) .dashboard-sidebar-launcher {
  display: none;
}
/* Portalled MUI dialogs do not inherit the editor's local --dn-* aliases. */
.debit-modal.MuiPaper-root {
  background: var(--surface-primary);
  color: var(--text-primary);
  border: 1px solid var(--border-subtle);
  font: 400 13px/1.6 var(--font-family-primary, sans-serif);
}
.debit-modal.MuiPaper-root p {
  font-size: 13px;
  line-height: 1.6;
}
.debit-modal.MuiPaper-root h2 {
  margin: 0 0 16px;
  font-size: 18px;
  line-height: 1.4;
  font-weight: 600;
}
.debit-modal.MuiPaper-root .debit-modal-actions {
  gap: var(--space-3, 12px);
}
.debit-modal.MuiPaper-root
  .debit-modal-actions
  .MuiButton-root.debit-secondary-button,
.debit-modal.MuiPaper-root
  .debit-modal-actions
  .MuiButton-root.debit-primary-button,
.debit-modal.MuiPaper-root
  .debit-modal-actions
  .MuiButton-root.debit-danger-button {
  min-width: 0;
  height: 40px;
  padding: 0 var(--space-3, 12px);
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: var(--radius-md, 10px);
  background: var(--surface-primary, #fff);
  color: var(--text-primary, #142624) !important;
  font: var(--font-weight-medium, 500) 13px/normal
    var(--font-family-primary, "Lexend", sans-serif);
  letter-spacing: 0;
  text-transform: none;
  box-shadow: none;
}
.debit-modal.MuiPaper-root
  .debit-modal-actions
  .MuiButton-root.debit-primary-button {
  border-color: var(--interactive-default, #0f766e);
  background: var(--interactive-default, #0f766e);
  color: var(--on-interactive-primary, #fff) !important;
}
.debit-modal.MuiPaper-root
  .debit-modal-actions
  .MuiButton-root.debit-secondary-button:hover:not(.Mui-disabled) {
  border-color: var(--interactive-default, #0f766e);
  background: var(--interactive-soft-hover, #e4f2f0);
  color: var(--text-primary, #142624) !important;
}
.debit-modal.MuiPaper-root
  .debit-modal-actions
  .MuiButton-root.debit-primary-button:hover:not(.Mui-disabled) {
  border-color: var(--interactive-hover, #0c5f59);
  background: var(--interactive-hover, #0c5f59);
  color: var(--on-interactive-primary, #fff) !important;
}
.debit-modal.MuiPaper-root
  .debit-modal-actions
  .MuiButton-root.debit-primary-button:active:not(.Mui-disabled) {
  border-color: var(--interactive-pressed, #0a4a46);
  background: var(--interactive-pressed, #0a4a46);
}
.debit-modal.MuiPaper-root
  .debit-modal-actions
  .MuiButton-root:focus-visible {
  outline: 2px solid var(--focus-ring, #41a89e);
  outline-offset: 2px;
}
.debit-editor-topbar {
  background: var(--surface-primary);
}
.debit-preview-desktop {
  align-self: start;
  min-height: 0;
  height: auto;
}
.debit-preview h2,
.debit-form-section > label,
.debit-form-section > h2 {
  font-weight: 500;
}

/* Keep the same column tracks while loading, filtering and displaying long values. */
@media (min-width: 1101px) {
  .adjustment-register .note-table-scroll table { table-layout: fixed; }
  .adjustment-register .note-table-scroll th,
  .adjustment-register .note-table-scroll td { overflow-wrap: anywhere; }
  .adjustment-register .note-table-scroll th,
  .adjustment-register .note-table-scroll .note-reference { white-space: normal; }
}
@media (max-width: 1100px) {
  .adjustment-register .note-table-scroll colgroup { display: none; }
}
.adjustment-register .app-skeleton-tr .app-skeleton { max-width: 100%; }
/* Reserve the browser scrollbar before shorter skeletons become long documents. */
html:has(.adjustment-register, .credit-detail-shell, .debit-editor-page) {
  scrollbar-gutter: stable;
}
`, "",{"version":3,"sources":["webpack://./src/layouts/AdjustmentNotes/adjustmentNotes.css"],"names":[],"mappings":"AAEA;EACE,kCAAkC;EAClC,sCAAsC;EACtC,qCAAqC;EACrC,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,eAAe;EACf,4BAA4B;AAC9B;AACA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,oCAAoC;EACpC,mBAAmB;EACnB,4CAA4C;AAC9C;AACA;EACE,kBAAkB;EAClB,6CAA6C;EAC7C,sBAAsB;AACxB;AACA;;EAEE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,iCAAiC;EACjC,+CAA+C;EAC/C,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,iDAAiD;AACnD;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,6DAA6D;EAC7D,4BAA4B;AAC9B;AACA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;AACA;;EAEE,4BAA4B;EAC5B,uBAAuB;AACzB;AACA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,eAAe;AACjB;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,kCAAkC;EAClC,4BAA4B;EAC5B,oCAAoC;EACpC,eAAe;AACjB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,wCAAwC;EACxC,mCAAmC;EACnC,+BAA+B;AACjC;AACA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;AAC9B;AACA;EACE,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,wCAAwC;EACxC,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,4BAA4B;AAC9B;AACA;;EAEE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,uCAAuC;EACvC,qCAAqC;EACrC,kCAAkC;EAClC,0BAA0B;EAC1B,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;;IAEE,aAAa;IACb,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;;IAEE,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,SAAS;EACT,SAAS;AACX;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;AACA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;;EAGE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,4CAA4C;EAC5C,SAAS;EACT,cAAc;EACd,WAAW;EACX,YAAY;AACd;AACA;;EAEE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;EAEE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,gDAAgD;EAChD,qCAAqC;EACrC,eAAe;EACf,gBAAgB;AAClB;AACA;;EAEE,2CAA2C;AAC7C;AACA;;;;;EAKE,iBAAiB;EACjB,oBAAoB;EACpB,iDAAiD;EACjD,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,+CAA+C;EAC/C,mBAAmB;EACnB,wCAAwC;EACxC,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,0DAA0D;AAC5D;AACA;EACE,6CAA6C;EAC7C,4CAA4C;EAC5C,mCAAmC;EACnC,qBAAqB;AACvB;AACA;EACE;IACE,aAAa;IACb,gDAAgD;IAChD,WAAW;EACb;EACA;;IAEE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;EACA;;IAEE,iBAAiB;EACnB;AACF;AACA;EACE,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,+BAA+B;EAC/B,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;AACjB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,UAAU;AACZ;AACA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;IACf,eAAe;EACjB;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,0BAA0B;EAC1B,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,oCAAoC;AACtC;AACA;EACE;IACE,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,UAAU;IACV,iBAAiB;IACjB,4BAA4B;IAC5B,eAAe;EACjB;AACF;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;EACpB,+CAA+C;AACjD;AACA;EACE,kBAAkB;EAClB,+CAA+C;AACjD;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,cAAc;EAChB;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,eAAe;EACjB;AACF;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sCAAsC;EACtC,+BAA+B;EAC/B,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,SAAS;EACT,4BAA4B;EAC5B,eAAe;AACjB;AACA;EACE,+CAA+C;EAC/C,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;;EAEE,aAAa;AACf;AACA,4EAA4E;AAC5E;EACE,kCAAkC;EAClC,0BAA0B;EAC1B,sCAAsC;EACtC,yDAAyD;AAC3D;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;;;;;;;;;EASE,YAAY;EACZ,YAAY;EACZ,+BAA+B;EAC/B,gDAAgD;EAChD,qCAAqC;EACrC,wCAAwC;EACxC,8CAA8C;EAC9C;oDACkD;EAClD,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;;;EAGE,iDAAiD;EACjD,+CAA+C;EAC/C,qDAAqD;AACvD;AACA;;;EAGE,iDAAiD;EACjD,kDAAkD;EAClD,8CAA8C;AAChD;AACA;;;EAGE,+CAA+C;EAC/C,6CAA6C;EAC7C,qDAAqD;AACvD;AACA;;;EAGE,iDAAiD;EACjD,+CAA+C;AACjD;AACA;;;EAGE,6CAA6C;EAC7C,mBAAmB;AACrB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,YAAY;AACd;AACA;;;EAGE,gBAAgB;AAClB;;AAEA,qFAAqF;AACrF;EACE,gDAAgD,mBAAmB,EAAE;EACrE;+CAC6C,uBAAuB,EAAE;EACtE;4DAC0D,mBAAmB,EAAE;AACjF;AACA;EACE,mDAAmD,aAAa,EAAE;AACpE;AACA,sDAAsD,eAAe,EAAE;AACvE,kFAAkF;AAClF;EACE,wBAAwB;AAC1B","sourcesContent":["@import \"../../styles/register-page-layout.css\";\n\n.note-register-card {\n  background: var(--surface-primary);\n  border: 1px solid var(--border-subtle);\n  border-radius: var(--radius-lg, 16px);\n  box-shadow: var(--shadow-sm);\n  overflow: hidden;\n}\n.note-register-summary,\n.note-register-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  padding: 16px;\n  font-size: 13px;\n  color: var(--text-secondary);\n}\n.note-register-summary strong {\n  color: var(--text-primary);\n  font-weight: 500;\n}\n.note-table-scroll {\n  overflow-x: auto;\n}\n.note-table-scroll table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n  line-height: 1.5;\n}\n.note-table-scroll th {\n  padding: 12px 16px;\n  text-align: left;\n  font-weight: 500;\n  color: var(--text-secondary);\n  background: var(--surface-secondary);\n  white-space: nowrap;\n  border-block: 1px solid var(--border-subtle);\n}\n.note-table-scroll td {\n  padding: 18px 16px;\n  border-bottom: 1px solid var(--border-subtle);\n  vertical-align: middle;\n}\n.note-table-scroll th:nth-last-child(2),\n.note-amount {\n  text-align: right;\n  white-space: nowrap;\n}\n.note-table-scroll td.note-contact {\n  max-width: 190px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.note-table-scroll .note-reference {\n  color: var(--interactive-default);\n  font-family: var(--font-family-mono, monospace);\n  text-decoration: none;\n  white-space: nowrap;\n}\n.note-table-scroll .note-reference:hover {\n  text-decoration: underline;\n}\n.note-amount {\n  font: 500 15px var(--font-family-mono, monospace);\n}\n.note-status {\n  display: inline-block;\n  padding: 3px 6px;\n  border-radius: var(--radius-full, 999px);\n  font-size: 11px;\n  font-weight: 500;\n  white-space: nowrap;\n  background: var(--surface-tertiary, var(--surface-secondary));\n  color: var(--text-secondary);\n}\n.note-status-applied {\n  background: var(--success-soft);\n  color: var(--success-text);\n}\n.note-status-issued,\n.note-status-refunded {\n  background: var(--info-soft);\n  color: var(--info-text);\n}\n.note-status-awaiting-confirmation {\n  background: var(--warning-soft);\n  color: var(--warning-text);\n}\n.note-delivery-failed {\n  display: block;\n  color: var(--danger-text);\n  font-size: 11px;\n  margin-top: 5px;\n}\n.note-register-footer div {\n  display: flex;\n  gap: 8px;\n}\n.note-register-footer button {\n  display: grid;\n  place-items: center;\n  width: 32px;\n  height: 32px;\n  border: 1px solid var(--border-default);\n  background: var(--surface-primary);\n  color: var(--text-secondary);\n  border-radius: var(--radius-sm, 6px);\n  cursor: pointer;\n}\n.note-register-footer button:disabled {\n  opacity: 0.4;\n  cursor: default;\n}\n.note-register-footer button:not(:disabled):hover {\n  border-color: var(--interactive-default);\n  background: var(--interactive-soft);\n  color: var(--interactive-hover);\n}\n.note-register-footer button:focus-visible {\n  outline: 2px solid var(--focus-ring);\n  outline-offset: 2px;\n}\n.note-register-guidance {\n  margin: 24px 0;\n  font-size: 13px;\n  line-height: 1.6;\n  color: var(--text-secondary);\n}\n.note-empty {\n  padding: 48px 24px;\n  text-align: center;\n  color: var(--text-secondary);\n}\n.note-empty h2 {\n  font-size: 18px;\n  color: var(--text-primary);\n}\n.debit-confirm-checkbox {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 16px 0;\n  font-size: 13px;\n  line-height: 1.5;\n}\n.debit-confirm-checkbox input {\n  margin-top: 3px;\n  accent-color: var(--interactive-default);\n  width: 18px;\n  height: 18px;\n  flex: 0 0 18px;\n}\n.debit-modal {\n  background: var(--surface-primary);\n  color: var(--text-primary);\n}\n.debit-page .debit-description input {\n  width: 100%;\n}\n.note-confirm-grid {\n  display: grid;\n  gap: 18px;\n}\n.note-confirm-grid label {\n  display: grid;\n  gap: 8px;\n  font-size: 13px;\n  color: var(--text-secondary);\n}\n.note-confirm-grid input,\n.note-confirm-grid select {\n  width: 100%;\n  min-height: 42px;\n  padding: 10px 12px;\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-md, 10px);\n  background: var(--surface-primary);\n  color: var(--text-primary);\n  font: inherit;\n}\n.note-confirm-grid .debit-confirm-checkbox {\n  display: flex;\n}\n.note-confirm-grid .debit-confirm-checkbox input {\n  width: 18px;\n  min-height: 18px;\n  padding: 0;\n}\n.note-detail-events {\n  padding-left: 20px;\n  color: var(--text-secondary);\n  font-size: 13px;\n  line-height: 1.8;\n}\n@media (max-width: 767px) {\n  .note-register-summary,\n  .note-register-footer {\n    padding: 12px;\n    font-size: 11px;\n  }\n  .note-table-scroll table {\n    min-width: 920px;\n  }\n  .note-table-scroll td,\n  .note-table-scroll th {\n    padding: 14px 12px;\n  }\n  .note-register-guidance {\n    font-size: 12px;\n    margin-top: 20px;\n  }\n  .adjustment-register .debit-search {\n    flex: 1 0 100%;\n    width: 100%;\n  }\n  .adjustment-register .debit-filters {\n    flex-wrap: wrap;\n  }\n  .adjustment-register .debit-filter-group {\n    width: 100%;\n  }\n  .adjustment-register .debit-filter-group > * {\n    flex: 1 1 120px;\n  }\n}\n\n.debit-editor-form {\n  border: 0;\n  margin: 0;\n}\n.debit-page .debit-editor-title h1 {\n  font-size: 32px;\n  line-height: 40px;\n  letter-spacing: -0.48px;\n}\n@media (max-width: 1024px) {\n  .debit-page .debit-editor-title h1 {\n    font-size: 28px;\n    line-height: 35px;\n  }\n}\n@media (max-width: 767px) {\n  .debit-page .debit-editor-title h1 {\n    font-size: 24px;\n    line-height: 30px;\n  }\n}\n.adjustment-register .debit-filter-group {\n  flex-wrap: wrap;\n  flex: 1 1 auto;\n}\n.adjustment-register .debit-filter-group > .quotation-figma-dropdown {\n  width: auto;\n  flex: 0 1 auto;\n  min-width: 130px;\n  max-width: 240px;\n}\n.adjustment-register\n  .debit-filter-group\n  > .quotation-figma-dropdown:last-child {\n  min-width: 150px;\n}\n.adjustment-register:is(.note-register--credit, .note-register--debit) .debit-filter-group {\n  display: grid;\n  grid-template-columns: repeat(3, 134px) auto;\n  gap: 12px;\n  flex: 0 1 auto;\n  width: auto;\n  min-width: 0;\n}\n.adjustment-register:is(.note-register--credit, .note-register--debit)\n  .debit-filter-group > .quotation-figma-dropdown {\n  flex: 0 0 134px;\n  width: 134px;\n  min-width: 134px;\n  max-width: 134px;\n}\n.adjustment-register:is(.note-register--credit, .note-register--debit)\n  .debit-filter-group .quotation-figma-dropdown-trigger {\n  box-sizing: border-box;\n  width: 100%;\n  min-width: 0;\n  height: 40px;\n  padding-inline: 12px;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: var(--radius-md, 10px);\n  font-size: 13px;\n  font-weight: 500;\n}\n.adjustment-register:is(.note-register--credit, .note-register--debit)\n  .debit-filter-group .quotation-figma-dropdown-trigger:hover {\n  border-color: var(--border-strong, #aebab8);\n}\n.adjustment-register:is(.note-register--credit, .note-register--debit)\n  .debit-filter-group .quotation-figma-dropdown.is-open\n  .quotation-figma-dropdown-trigger,\n.adjustment-register:is(.note-register--credit, .note-register--debit)\n  .debit-filter-group .quotation-figma-dropdown-trigger:focus-visible {\n  border-width: 1px;\n  padding-inline: 12px;\n  border-color: var(--interactive-default, #0f766e);\n  box-shadow: none;\n}\n.adjustment-register:is(.note-register--credit, .note-register--debit) .debit-clear-filters {\n  justify-content: center;\n  height: 40px;\n  padding: 0 14px;\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: 10px;\n  background: var(--surface-primary, #fff);\n  color: var(--text-primary, #142624);\n  font-size: 13px;\n  font-weight: 500;\n  white-space: nowrap;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n.adjustment-register:is(.note-register--credit, .note-register--debit) .debit-clear-filters:hover {\n  background: var(--surface-secondary, #f4f7f7);\n  border-color: var(--border-default, #cdd6d4);\n  color: var(--text-primary, #142624);\n  text-decoration: none;\n}\n@media (max-width: 767px) {\n  .adjustment-register:is(.note-register--credit, .note-register--debit) .debit-filter-group {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    width: 100%;\n  }\n  .adjustment-register:is(.note-register--credit, .note-register--debit)\n    .debit-filter-group > .quotation-figma-dropdown {\n    width: 100%;\n    min-width: 0;\n    max-width: none;\n  }\n  .adjustment-register:is(.note-register--credit, .note-register--debit)\n    .debit-filter-group > .quotation-figma-dropdown:last-of-type {\n    grid-column: auto;\n  }\n}\n.debit-page .note-register-guidance {\n  margin-top: 24px;\n}\n.debit-page .listing-actions-trigger {\n  display: inline-grid;\n  place-items: center;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  border: 0;\n  border-radius: var(--radius-sm);\n  background: transparent;\n  color: var(--text-secondary);\n  cursor: pointer;\n}\n.debit-page .listing-actions-trigger:hover {\n  background: var(--surface-secondary);\n}\n.debit-source-select-wrap > svg {\n  display: none;\n}\n.debit-source-select .quotation-input-box {\n  height: 40px;\n}\n.debit-page .debit-source-select input {\n  border: 0;\n  background: transparent;\n  border-radius: 0;\n  box-shadow: none;\n  height: 38px;\n  padding: 0;\n}\n.debit-selected-source > div:first-child > span {\n  color: var(--text-primary);\n  font-weight: 500;\n}\n.debit-selected-source > div:last-child > strong {\n  color: var(--text-primary);\n  font-size: 15px;\n}\n.debit-editor-actions-bottom {\n  justify-content: flex-end;\n  width: 100%;\n}\n.debit-page .debit-lines-table {\n  overflow: hidden;\n}\n@media (max-width: 1024px) {\n  .adjustment-register .debit-filters {\n    flex-wrap: wrap;\n  }\n}\n@media (max-width: 767px) {\n  .adjustment-register .debit-filter-group > .quotation-figma-dropdown {\n    flex: 1 1 120px;\n    max-width: none;\n  }\n}\n.debit-organisation-menu > a {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 12px;\n  color: var(--text-primary);\n  text-decoration: none;\n  font-size: 13px;\n}\n.debit-organisation-menu > a:hover {\n  background: var(--surface-secondary);\n}\n@media (max-width: 767px) {\n  .debit-description .sr-only {\n    position: static;\n    width: auto;\n    height: auto;\n    margin: 0 0 6px;\n    clip: auto;\n    overflow: visible;\n    color: var(--text-secondary);\n    font-size: 12px;\n  }\n}\n.note-unit-field {\n  position: relative;\n  min-width: 0;\n  width: 100%;\n}\n.note-unit-field > span {\n  position: absolute;\n  left: 9px;\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none;\n  font-family: var(--font-family-mono, monospace);\n}\n.debit-page .note-unit-field input {\n  padding-left: 22px;\n  font-family: var(--font-family-mono, monospace);\n}\n.debit-preview .note-preview-lines {\n  display: none;\n}\n@media (max-width: 767px) {\n  .debit-preview-responsive .note-preview-lines {\n    display: block;\n  }\n  .note-preview-lines p {\n    display: flex;\n    justify-content: space-between;\n    gap: 12px;\n    font-size: 12px;\n  }\n}\n.note-confirm-balance {\n  padding: 12px 16px;\n  margin-block: 16px;\n  border: 1px solid var(--border-subtle);\n  border-radius: var(--radius-md);\n  background: var(--surface-secondary);\n}\n.note-confirm-balance p {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  gap: 16px;\n  color: var(--text-secondary);\n  font-size: 13px;\n}\n.note-confirm-balance strong {\n  font-family: var(--font-family-mono, monospace);\n  color: var(--text-primary);\n  white-space: nowrap;\n}\nbody:has(.debit-page) .dashboard-sidebar-launcher,\nbody:has(.credit-detail-shell) .dashboard-sidebar-launcher {\n  display: none;\n}\n/* Portalled MUI dialogs do not inherit the editor's local --dn-* aliases. */\n.debit-modal.MuiPaper-root {\n  background: var(--surface-primary);\n  color: var(--text-primary);\n  border: 1px solid var(--border-subtle);\n  font: 400 13px/1.6 var(--font-family-primary, sans-serif);\n}\n.debit-modal.MuiPaper-root p {\n  font-size: 13px;\n  line-height: 1.6;\n}\n.debit-modal.MuiPaper-root h2 {\n  margin: 0 0 16px;\n  font-size: 18px;\n  line-height: 1.4;\n  font-weight: 600;\n}\n.debit-modal.MuiPaper-root .debit-modal-actions {\n  gap: var(--space-3, 12px);\n}\n.debit-modal.MuiPaper-root\n  .debit-modal-actions\n  .MuiButton-root.debit-secondary-button,\n.debit-modal.MuiPaper-root\n  .debit-modal-actions\n  .MuiButton-root.debit-primary-button,\n.debit-modal.MuiPaper-root\n  .debit-modal-actions\n  .MuiButton-root.debit-danger-button {\n  min-width: 0;\n  height: 40px;\n  padding: 0 var(--space-3, 12px);\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: var(--radius-md, 10px);\n  background: var(--surface-primary, #fff);\n  color: var(--text-primary, #142624) !important;\n  font: var(--font-weight-medium, 500) 13px/normal\n    var(--font-family-primary, \"Lexend\", sans-serif);\n  letter-spacing: 0;\n  text-transform: none;\n  box-shadow: none;\n}\n.debit-modal.MuiPaper-root\n  .debit-modal-actions\n  .MuiButton-root.debit-primary-button {\n  border-color: var(--interactive-default, #0f766e);\n  background: var(--interactive-default, #0f766e);\n  color: var(--on-interactive-primary, #fff) !important;\n}\n.debit-modal.MuiPaper-root\n  .debit-modal-actions\n  .MuiButton-root.debit-secondary-button:hover:not(.Mui-disabled) {\n  border-color: var(--interactive-default, #0f766e);\n  background: var(--interactive-soft-hover, #e4f2f0);\n  color: var(--text-primary, #142624) !important;\n}\n.debit-modal.MuiPaper-root\n  .debit-modal-actions\n  .MuiButton-root.debit-primary-button:hover:not(.Mui-disabled) {\n  border-color: var(--interactive-hover, #0c5f59);\n  background: var(--interactive-hover, #0c5f59);\n  color: var(--on-interactive-primary, #fff) !important;\n}\n.debit-modal.MuiPaper-root\n  .debit-modal-actions\n  .MuiButton-root.debit-primary-button:active:not(.Mui-disabled) {\n  border-color: var(--interactive-pressed, #0a4a46);\n  background: var(--interactive-pressed, #0a4a46);\n}\n.debit-modal.MuiPaper-root\n  .debit-modal-actions\n  .MuiButton-root:focus-visible {\n  outline: 2px solid var(--focus-ring, #41a89e);\n  outline-offset: 2px;\n}\n.debit-editor-topbar {\n  background: var(--surface-primary);\n}\n.debit-preview-desktop {\n  align-self: start;\n  min-height: 0;\n  height: auto;\n}\n.debit-preview h2,\n.debit-form-section > label,\n.debit-form-section > h2 {\n  font-weight: 500;\n}\n\n/* Keep the same column tracks while loading, filtering and displaying long values. */\n@media (min-width: 1101px) {\n  .adjustment-register .note-table-scroll table { table-layout: fixed; }\n  .adjustment-register .note-table-scroll th,\n  .adjustment-register .note-table-scroll td { overflow-wrap: anywhere; }\n  .adjustment-register .note-table-scroll th,\n  .adjustment-register .note-table-scroll .note-reference { white-space: normal; }\n}\n@media (max-width: 1100px) {\n  .adjustment-register .note-table-scroll colgroup { display: none; }\n}\n.adjustment-register .app-skeleton-tr .app-skeleton { max-width: 100%; }\n/* Reserve the browser scrollbar before shorter skeletons become long documents. */\nhtml:has(.adjustment-register, .credit-detail-shell, .debit-editor-page) {\n  scrollbar-gutter: stable;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
